import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const createChargers: UseCase<ChargerRepository, 'createChargers'> = repository => {
  return async (groupUuid, chargers) => {
    return await repository.createChargers(groupUuid, chargers)
  }
}
